import type { FaireProductEntity } from "../../entity_types/product";

export const p_q76xvhdqad: FaireProductEntity = {
  token: "p_q76xvhdqad",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Equinox (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/96923152da9323dce06f06b8547c22ec3379df123e707fba82ec7c84cb4f8e8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/834ee0765e37535b8564fcb13c60063e14003df76b2d692f5a7c16f48f19585c.jpeg",
    "https://cdn.faire.com/fastly/e6ee8b8c49ca1587caf067971b21091d0c9ee225864c5ddc4b0478e04e5cead7.jpeg",
    "https://cdn.faire.com/fastly/41c9e406b54f1072925e6950f5acd67fa5c5d5249d5461763b04b7d865b7782d.jpeg",
    "https://cdn.faire.com/fastly/8d1d7978313a5257b1a50148e471b39233f5f20611d0df66f16b79aa6b6805a9.jpeg",
    "https://cdn.faire.com/fastly/8531f57fb81a8e0387d027ff6a9ec84907be34fcadb0ca83792bc9eaa5a616e9.jpeg",
    "https://cdn.faire.com/fastly/d9870fd41ab2ca67b15889436cedeab4d46de854e60fb54a5d32789be671ce7a.jpeg",
    "https://cdn.faire.com/fastly/2671b11931e5aa7b639b8e11f86a6557438324050b77220bed94ec1280bd61ea.jpeg",
    "https://cdn.faire.com/fastly/cc790fa064014855d03c1f5f03c2b7ac557c3c5d0038b2acf9b28a86e2ee4561.jpeg",
    "https://cdn.faire.com/fastly/56d037e859e071e008e67514a9bc4c2540aeabafeadc0c2124d612a4ae57238b.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:22.837Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
